import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AlertModule } from 'ng2-bootstrap';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { SingleTransactionsComponent } from './single-transactions/single-transactions.component';
import { Ng2PaginationModule } from 'ng2-pagination';
import { MatchedTransactionsComponent } from './matched-transactions/matched-transactions.component';
import { UnmatchedTransactionsComponent } from './unmatched-transactions/unmatched-transactions.component';
import { UnmatchedTransactionDetailComponent } from './unmatched-transaction-detail/unmatched-transaction-detail.component';
import { StudentRelatedDisbursementsComponent } from './student-related-disbursements/student-related-disbursements.component';
import { MatchedTransactionDetailComponent } from './matched-transaction-detail/matched-transaction-detail.component';
import { ArchivedTransactionsComponent } from './archived-transactions/archived-transactions.component';
import { ArchivedTransactionDetailComponent } from './archived-transaction-detail/archived-transaction-detail.component';
import { CurrentBatchTransactionsComponent } from './current-batch-transactions/current-batch-transactions.component';
import { CurrentBatchTransactionDetailComponent } from './current-batch-transaction-detail/current-batch-transaction-detail.component';


const appRoutes: Routes = [
  { path: 'app/diamond-pay/single-transactions',        component: SingleTransactionsComponent },
  { path: 'app/diamond-pay/matched-transactions',       component: MatchedTransactionsComponent },
  { path: 'app/diamond-pay/matched-transactions/:id',   component: MatchedTransactionDetailComponent },
  { path: 'app/diamond-pay/unmatched-transactions',     component: UnmatchedTransactionsComponent },
  { path: 'app/diamond-pay/unmatched-transactions/:id', component: UnmatchedTransactionDetailComponent },
  { path: 'app/diamond-pay/archived-transactions',      component: ArchivedTransactionsComponent },
  { path: 'app/diamond-pay/archived-transactions/:id',  component: ArchivedTransactionDetailComponent },
  { path: 'app/diamond-pay/queued-transactions',        component: CurrentBatchTransactionsComponent },
  { path: 'app/diamond-pay/queued-transactions/:id',    component: CurrentBatchTransactionDetailComponent },
  { path: '',
    redirectTo: '/app/diamond-pay/unmatched-transactions',
    pathMatch: 'full'
  },
  //{ path: '**', component: PageNotFoundComponent }
];


@NgModule({
  declarations: [
    AppComponent,
    SingleTransactionsComponent,
    MatchedTransactionsComponent,
    UnmatchedTransactionsComponent,
    UnmatchedTransactionDetailComponent,
    StudentRelatedDisbursementsComponent,
    MatchedTransactionDetailComponent,
    ArchivedTransactionsComponent,
    ArchivedTransactionDetailComponent,
    CurrentBatchTransactionsComponent,
    CurrentBatchTransactionDetailComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AlertModule.forRoot(),
    RouterModule.forRoot(appRoutes),
    Ng2PaginationModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts